import SvgIcon from '@mui/material/SvgIcon';
import classNames from 'classnames';

import { useStyles } from './Reactions.styles';
import { ReactionProps } from './Reactions.types';

export const Bomb = ({
  size = 'default',
  color = 'secondary',
}: ReactionProps) => {
  const { classes } = useStyles();

  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(
        classes[`icon_size_${size}` as const],
        classes[`icon_color_${color}` as const],
      )}
    >
      <g clipPath="url(#clip0_4706_230591)">
        <path
          d="M14.8591 5.23257C14.3647 5.48905 13.9066 5.94348 13.5959 6.37785C13.4068 6.64218 12.957 6.22331 13.146 5.95897C13.4881 5.48075 14.0024 4.96285 14.5871 4.65952C15.1719 4.35619 16.2221 3.97363 16.2221 3.97363L16.4413 4.58847C16.4413 4.58847 15.3536 4.97609 14.8591 5.23257Z"
          fill="url(#paint0_linear_4706_230591)"
        />
        <path
          d="M14.8591 5.23257C14.3647 5.48905 13.9066 5.94348 13.5959 6.37785C13.4068 6.64218 12.957 6.22331 13.146 5.95897C13.4881 5.48075 14.0024 4.96285 14.5871 4.65952C15.1719 4.35619 16.2221 3.97363 16.2221 3.97363L16.4413 4.58847C16.4413 4.58847 15.3536 4.97609 14.8591 5.23257Z"
          fill="url(#paint1_radial_4706_230591)"
        />
        <path
          d="M14.1397 5.32934C13.5797 4.7402 12.9455 4.50005 12.5216 4.40216C12.2164 4.33169 11.9137 4.46018 11.6935 4.68298L10.1895 6.20508L13.1592 9.17482L14.6547 7.67929C14.8865 7.44751 15.0138 7.12727 14.9345 6.80921C14.8341 6.40649 14.6151 5.8296 14.1397 5.32934Z"
          fill="url(#paint2_linear_4706_230591)"
        />
        <path
          d="M14.1397 5.32934C13.5797 4.7402 12.9455 4.50005 12.5216 4.40216C12.2164 4.33169 11.9137 4.46018 11.6935 4.68298L10.1895 6.20508L13.1592 9.17482L14.6547 7.67929C14.8865 7.44751 15.0138 7.12727 14.9345 6.80921C14.8341 6.40649 14.6151 5.8296 14.1397 5.32934Z"
          fill="url(#paint3_radial_4706_230591)"
          fillOpacity="0.6"
        />
        <path
          d="M7.94855 18.0397C11.5272 18.0397 14.4283 15.1386 14.4283 11.5599C14.4283 7.98118 11.5272 5.08008 7.94855 5.08008C4.36985 5.08008 1.46875 7.98118 1.46875 11.5599C1.46875 15.1386 4.36985 18.0397 7.94855 18.0397Z"
          fill="url(#paint4_linear_4706_230591)"
        />
        <path
          opacity="0.7"
          d="M7.94855 18.0397C11.5272 18.0397 14.4283 15.1386 14.4283 11.5599C14.4283 7.98118 11.5272 5.08008 7.94855 5.08008C4.36985 5.08008 1.46875 7.98118 1.46875 11.5599C1.46875 15.1386 4.36985 18.0397 7.94855 18.0397Z"
          fill="url(#paint5_radial_4706_230591)"
        />
        <path
          d="M7.94855 18.0397C11.5272 18.0397 14.4283 15.1386 14.4283 11.5599C14.4283 7.98118 11.5272 5.08008 7.94855 5.08008C4.36985 5.08008 1.46875 7.98118 1.46875 11.5599C1.46875 15.1386 4.36985 18.0397 7.94855 18.0397Z"
          fill="url(#paint6_radial_4706_230591)"
        />
        <path
          opacity="0.9"
          d="M7.94855 18.0397C11.5272 18.0397 14.4283 15.1386 14.4283 11.5599C14.4283 7.98118 11.5272 5.08008 7.94855 5.08008C4.36985 5.08008 1.46875 7.98118 1.46875 11.5599C1.46875 15.1386 4.36985 18.0397 7.94855 18.0397Z"
          fill="url(#paint7_radial_4706_230591)"
          fillOpacity="0.6"
        />
        <g filter="url(#filter0_f_4706_230591)">
          <path
            d="M14.1421 11.4912C14.1421 14.8406 11.4269 17.5558 8.07751 17.5558C6.63068 17.5558 5.30218 17.0491 4.25977 16.2035C8.87863 16.9222 12.6097 13.9027 14.1421 11.4912Z"
            fill="url(#paint8_linear_4706_230591)"
          />
        </g>
        <path
          d="M18.0789 0.898757C18.1297 0.832788 18.2348 0.881644 18.2171 0.963058L17.7917 2.92098C17.7831 2.96052 17.8061 3.00007 17.8448 3.01213L19.295 3.46506C19.3662 3.4873 19.3687 3.58714 19.2987 3.61294L17.8714 4.13892C17.8312 4.15375 17.8104 4.19825 17.8249 4.23862L18.3986 5.8371C18.4256 5.91227 18.3358 5.97471 18.2747 5.92321L16.9959 4.84419C16.9616 4.81525 16.91 4.82109 16.8831 4.85698L15.9178 6.14202C15.8702 6.20538 15.7694 6.16581 15.7776 6.087L15.9517 4.41708C15.9556 4.3801 15.9328 4.34552 15.8973 4.33442L14.8391 4.00323C14.7735 3.98272 14.7645 3.8937 14.8245 3.86037L15.7895 3.32453C15.824 3.30537 15.8388 3.26348 15.824 3.2269L15.2396 1.78427C15.2102 1.71171 15.294 1.64583 15.3576 1.69145L16.6546 2.62182C16.6888 2.64636 16.7363 2.63938 16.762 2.60606L18.0789 0.898757Z"
          fill="url(#paint9_linear_4706_230591)"
        />
        <path
          d="M17.5485 2.17455C17.574 2.14157 17.6265 2.166 17.6176 2.2067L17.394 3.23591C17.3897 3.25595 17.4016 3.27595 17.4212 3.2817L18.2839 3.53355C18.321 3.5444 18.3215 3.59685 18.2846 3.60835L17.4368 3.87209C17.4156 3.8787 17.4041 3.90166 17.4116 3.92259L17.7128 4.76174C17.7263 4.79932 17.6814 4.83054 17.6509 4.80479L16.9778 4.2369C16.9607 4.22242 16.9349 4.22535 16.9214 4.24329L16.4133 4.91973C16.3895 4.9514 16.3391 4.93162 16.3432 4.89221L16.4348 4.01393C16.4367 3.99544 16.4253 3.97815 16.4076 3.9726L15.8506 3.7983C15.8179 3.78805 15.8133 3.74354 15.8433 3.72687L16.3513 3.4448C16.3686 3.43522 16.376 3.41428 16.3686 3.39599L16.0611 2.63688C16.0464 2.6006 16.0883 2.56766 16.1201 2.59048L16.8025 3.08C16.8196 3.09227 16.8433 3.08878 16.8562 3.07212L17.5485 2.17455Z"
          fill="url(#paint10_radial_4706_230591)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_4706_230591"
          x="3.86914"
          y="11.1006"
          width="10.6631"
          height="6.8457"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.195312"
            result="effect1_foregroundBlur_4706_230591"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4706_230591"
          x1="15.7616"
          y1="4.30412"
          x2="14.4191"
          y2="5.42535"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D3B99B" />
          <stop offset="1" stopColor="#B59171" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_4706_230591"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.0124 4.4369) rotate(156.842) scale(1.85295 2.29135)"
        >
          <stop stopColor="#5A0000" />
          <stop offset="1" stopColor="#D3AC9B" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_4706_230591"
          x1="11.0486"
          y1="5.25312"
          x2="14.2232"
          y2="8.00205"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#182031" />
          <stop offset="0.270233" stopColor="#516185" />
          <stop offset="0.708333" stopColor="#05080F" />
          <stop offset="1" stopColor="#101622" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_4706_230591"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.2856 6.56926) rotate(161.205) scale(3.77742 3.40787)"
        >
          <stop offset="0.145833" stopColor="#FF0D47" />
          <stop offset="1" stopColor="#1A202B" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_4706_230591"
          x1="12.5032"
          y1="16.5578"
          x2="3.47079"
          y2="6.26824"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D2533" />
          <stop offset="0.263434" stopColor="#0B0E15" />
          <stop offset="1" stopColor="#445579" />
        </linearGradient>
        <radialGradient
          id="paint5_radial_4706_230591"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.47283 8.22372) rotate(-132.357) scale(4.83699 5.2676)"
        >
          <stop offset="0.00196462" stopColor="#95ABDF" />
          <stop offset="1" stopColor="#2F3E58" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_4706_230591"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.94855 11.5599) scale(7.02072)"
        >
          <stop offset="0.768455" stopColor="#364462" stopOpacity="0" />
          <stop offset="1" stopColor="#0E1424" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_4706_230591"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.1091 8.14872) rotate(149.034) scale(6.62962 8.67627)"
        >
          <stop offset="0.10808" stopColor="#FF0B37" />
          <stop offset="1" stopColor="#161720" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint8_linear_4706_230591"
          x1="11.6146"
          y1="16.7217"
          x2="9.94928"
          y2="14.0573"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#51689E" />
          <stop offset="0.808387" stopColor="#151A23" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_4706_230591"
          x1="18.0554"
          y1="1.17152"
          x2="15.7224"
          y2="6.36912"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7E96" />
          <stop offset="0.42" stopColor="#FF2943" />
          <stop offset="1" stopColor="#B00C30" />
        </linearGradient>
        <radialGradient
          id="paint10_radial_4706_230591"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.5436 2.20228) rotate(24.1733) scale(2.44965 3.06162)"
        >
          <stop stopColor="#FFF1B6" />
          <stop offset="0.458333" stopColor="#FFD400" />
          <stop offset="1" stopColor="#FF8E00" />
        </radialGradient>
        <clipPath id="clip0_4706_230591">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
